(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tolin-turkey-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tolin-turkey-hero')) {
    class TolinTurkeyHero extends HTMLElement {
      constructor() {
        super()
        this.currentIndex = 0
        this.scrollFrame = null
        this.handleScroll = this.handleScroll.bind(this)
      }

      connectedCallback() {
        this.viewport = this.querySelector('[data-hero-viewport]')
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'))
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'))
        this.previousButton = this.querySelector('[data-hero-previous]')
        this.nextButton = this.querySelector('[data-hero-next]')
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

        if (!this.viewport || this.slides.length === 0) return

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1))
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1))
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.heroDot))))
        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true })
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-hero-slide]')
          if (slide) this.goTo(this.slides.indexOf(slide), 'auto')
        })

        this.setupProductMotion()
        this.updateState(0)
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.handleScroll)
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame)
        this.motionCleanups?.forEach((cleanup) => cleanup())
      }

      goTo(index, behavior) {
        const targetIndex = (index + this.slides.length) % this.slides.length
        const target = this.slides[targetIndex]
        this.viewport.scrollTo({ left: target.offsetLeft, behavior: behavior || (this.reducedMotion ? 'auto' : 'smooth') })
        this.updateState(targetIndex)
      }

      handleScroll() {
        if (this.scrollFrame) return
        this.scrollFrame = requestAnimationFrame(() => {
          const viewportLeft = this.viewport.scrollLeft
          let nearestIndex = 0
          let nearestDistance = Number.POSITIVE_INFINITY

          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - viewportLeft)
            if (distance < nearestDistance) {
              nearestDistance = distance
              nearestIndex = index
            }
          })

          this.updateState(nearestIndex)
          this.scrollFrame = null
        })
      }

      updateState(index) {
        this.currentIndex = index
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index
          slide.classList.toggle('is-active', isActive)
          slide.setAttribute('aria-hidden', String(!isActive))
          slide.inert = !isActive
        })
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index
          dot.classList.toggle('is-active', isActive)
          dot.setAttribute('aria-current', String(isActive))
        })
      }

      setupProductMotion() {
        const motionAllowed =
          this.dataset.productMotion === 'true' &&
          window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)').matches

        if (!motionAllowed) return
        this.motionCleanups = []

        this.querySelectorAll('[data-hero-visual]').forEach((visual) => {
          const product = visual.querySelector('[data-floating-product]')
          if (!product) return
          let frame = null

          const move = (event) => {
            const bounds = visual.getBoundingClientRect()
            const x = (event.clientX - bounds.left) / bounds.width - 0.5
            const y = (event.clientY - bounds.top) / bounds.height - 0.5
            if (frame) return
            frame = requestAnimationFrame(() => {
              product.style.transform = `translate3d(${x * 8}px, ${y * 5}px, 0) rotateX(${y * -8}deg) rotateY(${x * 8}deg)`
              frame = null
            })
          }

          const reset = () => {
            if (frame) cancelAnimationFrame(frame)
            frame = null
            product.style.transform = ''
          }

          visual.addEventListener('pointermove', move, { passive: true })
          visual.addEventListener('pointerleave', reset)
          this.motionCleanups.push(() => {
            visual.removeEventListener('pointermove', move)
            visual.removeEventListener('pointerleave', reset)
            if (frame) cancelAnimationFrame(frame)
          })
        })
      }
    }

    customElements.define('tolin-turkey-hero', TolinTurkeyHero)
  }

  } catch(e) { console.error(e); }
})();
})();
